import { type RoleRepository } from "@telespot/domain";
import { type CommandHandler } from "@telespot/core";

import { GrantRoles } from "./grant-roles.command";

/**
 * Errors thrown by {@link GrantRolesHandler}
 *
 * @group Authentication & Authorization
 * @category Errors
 */
export enum GrantRoleErrors {
  ROLE_NOT_FOUND = "Role does not exist",
}

/**
 * Handler interface for {@link GrantRoles}
 *
 * @group Authentication & Authorization
 * @category Handlers
 */
export type IGrantRolesHandler = CommandHandler<GrantRoles>;

/**
 * Default handler implementation for {@link GrantRoles}
 *
 * @group Authentication & Authorization
 * @category Handlers
 */
export class GrantRolesHandler implements IGrantRolesHandler {

  constructor(private readonly roles: RoleRepository) { }

  public async execute(command: GrantRoles): Promise<void> {

    const { roles, userId } = command.details;

    // REVIEW: only list the roles needed for the operation
    const existingRoles = await this.roles.list();

    const affectedRoles = existingRoles.filter(r => roles.includes(r.name));

    for (const name of roles) {
      const role = affectedRoles.find(r => r.name === name);

      if (!role) throw new Error(`${GrantRoleErrors.ROLE_NOT_FOUND}: ${name}`);

      role.grantTo(userId);
    }

    await this.roles.save(affectedRoles);
  }

}
